'use strict';

const _ = require('lodash');
const AttributeTypes = require('../../V4/Attribute').Types;

/**
 * Direct method-for-method port of the Rule.BL.Validation.DefaultApplier
 */
module.exports = class DefaultApplier {
    /**
     * Input validation and normalization for rule validation. Performs naive null-check validation on the inputs
     * then normalizes attributeSelection using default selections defined by the rule set's white list.
     * @param {*} ruleSet The rule set to validate.
     * @param {*} attributeSelection The attribute selection to validate.
     */
    static applyDefaults(ruleSet, attributeSelection) {
        if (_.isNil(ruleSet)) {
            const error = new Error('ruleSet was null or undefined');
            throw error;
        }

        if (_.isNil(ruleSet.whiteList)) {
            const error = new Error('ruleSet\'s white list was null or undefined');
            throw error;
        }

        if (_.isNil(attributeSelection)) {
            const error = new Error('attribute selection was null or undefined');
            throw error;
        }

        _.each(ruleSet.whiteList, (whiteListedAttribute) => {
            if (!_.isNil(whiteListedAttribute.defaultAttributeValue) || !_.isNil(whiteListedAttribute.defaultAttributeRange)) {
                if (!_.has(attributeSelection, whiteListedAttribute.attributeKey)) {
                    if (whiteListedAttribute.type === AttributeTypes.listOfValues) {
                        attributeSelection[whiteListedAttribute.attributeKey] = whiteListedAttribute.defaultAttributeValue.toString();
                    }
                    else if (whiteListedAttribute.type === AttributeTypes.listOfRanges) {
                        attributeSelection[whiteListedAttribute.attributeKey] = whiteListedAttribute.defaultAttributeRange.toString();
                    }
                    else {
                        const typeNotSupportedError = new Error(`Given attribute type is not supported: ${whiteListedAttribute.type}. Attribute: ${JSON.stringify(whiteListedAttribute)}`);
                        throw typeNotSupportedError;
                    }
                }
            }
        });
    }
};
